// extracted by mini-css-extract-plugin
export default {"container-separator":"divkit-a7719","container-separator__item":"divkit-c770e","container-separator__shape":"divkit-f6e9a"};